import { FunctionComponent } from 'react';
import NavModule, { NavModuleProps } from './NavModule/NavModule';

import styles from './NavLeft.module.scss';

export type NavLeftProps = {
  modules: NavModuleProps[];
  expandMenu: boolean;
};

type FC = FunctionComponent<NavLeftProps>;

const NavLeft: FC = ({ modules, expandMenu }: NavLeftProps) => (
  <div className={styles.container}>
    {modules.map((props, idx) => (
      <NavModule key={`module-${idx}`} {...props} expandMenu={expandMenu} />
    ))}
  </div>
);

export default NavLeft;
